export const OBJECT_VALUES = {
    ADD_ITEM: "click-qr-menu-item",
    ADD_PIN: "click-qr-menu-add-pin",
    GO_TO_CART_IMPRESSION_CONTAINER: "impression-go-to-cart",
    GO_TO_CART_CLICK_CONTAINER: "click-go-to-cart",
};

export const OBJECT_NAMES = {
    SEARCH_BAR_IMPRESSION: "impression-search-bar",
    SEARCH_BAR_QUERY_CHANGE: "Enter-Search-Query",
};

export const goToCartWidgetAnalyticsInfo = {
    action: "bottom_bar",
    value: 9999,
};
